import ToastContainer from "./Toast";
const Toast = ToastContainer;
export default Toast;
